<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <div>
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6 text-muted">
                      Page {{ authorsPagination.page }} / {{ authorsPagination.pages }}
                      - {{ authorsPagination.total }} élément(s)
                    </div>
                    <div class="col-md-6 text-right">
                      <a href @click.prevent="filters.display = !filters.display; setPage(1)" class="btn btn-info m-r-10">
                        <i class="fa fa-filter"></i>
                        Filtrer
                      </a>
                      <a href @click.prevent="createAuthor()" class="btn btn-default">
                        <i class="fa fa-plus"></i>
                        Ajouter un rédacteur
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive">
                  <form
                    class=""
                    @submit.prevent="setPage(1)"
                    v-if="filters.display">
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <input
                            v-model="filters.term"
                            @change="setPage(1)"
                            type="text"
                            placeholder="Filtrer par mots clés (nom)"
                            class="form-control">
                        </div>
                      </div>
                      <div class="col-md-4">
                        <el-select
                          clearable
                          @change="setPage(1)"
                          v-model="filters.status">
                          <el-option
                            v-for="item in constants.AUTHOR_STATUSES"
                            :label="$t(`${item}`)"
                            :key="item"
                            :value="item">
                              {{ $t(`${item}`) }}
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </form>
                  <table
                  v-loading="loading"
                  class="table table-hover">
                      <tbody>
                        <tr
                          @click="toAuthor(author.id)"
                          v-for="author in authors"
                          class="pointer">
                          <td style="width: 50px;">
                            <el-image
                              style="width: 50px; height: 50px"
                              :src="author.cover_image_url"
                              class="avatar border-gray"
                              fit="contain">
                              <div slot="error" class="image-slot">
                                <img :src="author.thumb_author_url" class="img-fluid">
                              </div>
                            </el-image>
                          </td>
                          <td>
                            <h5 class="m-b-10" :class="{'text-muted': !author.screenname}">
                              {{ author.screenname || 'Aucun nom' }}
                              <small>
                                <span class="badge badge-secondary">Rédacteur</span>
                              </small>
                              <br>
                              <small>
                                {{ author.created_at |  fromNowDate }}
                              </small>
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                  </table>
                  <hr class="m-t-10">
                  <div class="text-center">
                    <el-pagination
                      @size-change="setPage"
                      @current-change="setPage"
                      :page-size="authorsPagination.par_page"
                      :pager-count="5"
                      :page-count="authorsPagination.pages"
                      :page-sizes="[8, 16, 24, 50, 100]"
                      :current-page="authorsPagination.page"
                      layout="total, prev, pager, next">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- <pre>{{ authors }}</pre> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  computed: {
      ...mapGetters({
      globals: 'globals',
      constants: 'constants',
      authors: 'authors',
      author: 'author',
      authorsPagination: 'authorsPagination'
    }),
  },
  components: {
    VueTagsInput,
  },
  data () {
    return {
      loading: false,
      debounce: null,
      default_filters: null,
      filters: {
        status: null,
        term: null,
        page: 1,
        per_page: 25,
        display: false
      },
      mask: 'id,status,screenname,thumb_author_url,created_at'
    }
  },
  watch: {
    '$route' (to, from) {
      this.filters = Object.assign(this.filters, to.query)
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.loading = true
      this.$store.dispatch('getConstants', {
        params: {
          'keys': 'AUTHOR_STATUSES'
        }
      })
      if (this.default_filters === null) {
        this.default_filters = Object.assign({}, this.filters)
      }
      this.filters = Object.assign(this.filters, this.$route.query)
      this.$store.dispatch('getAuthors', {
        params: this.filters,
        headers: { 'x-fields': this.mask }
      }).then(() => {
        this.loading = false
      })
    },
    createAuthor () {
      this.$store.dispatch('createAuthor', {}).then(() => {
        this.$router.replace({
          name: 'author',
          params: {id: this.author.id}
        })
      })
    },
    toAuthor (authorId) {
      this.$router.push({
        name: 'author',
        params: {id: authorId}
      })
    },
    setPage (page) {
      if (this.filters.display === false && this.default_filters) {
        this.filters = Object.assign({}, this.default_filters)
      }
      this.filters.page = page
      this.$router.replace({
        name: 'authors',
        query: Object.assign({}, this.filters)
      })
      window.scrollTo(0,0)
    }
  }
}
</script>
<style>
</style>
